const DashboardTypes = {
  GET_DASHBOARD_ALL_ITEM_REQUEST: 'GET_DASHBOARD_ALL_ITEM_REQUEST',
  GET_DASHBOARD_ALL_ITEM_SUCCESS: 'GET_DASHBOARD_ALL_ITEM_SUCCESS',
  GET_DASHBOARD_ALL_ITEM_ERROR: 'GET_DASHBOARD_ALL_ITEM_ERROR',

  GET_FILTER_OPTIONS_REQUEST: 'GET_FILTER_OPTIONS_REQUEST',
  GET_FILTER_OPTIONS_SUCCESS: 'GET_FILTER_OPTIONS_SUCCESS',
  GET_FILTER_OPTIONS_ERROR: 'GET_FILTER_OPTIONS_ERROR'
};
export default DashboardTypes;
